module.exports = __webpack_public_path__ + "media/images/emoticons/clip-e5b0da586625ba75e32aa73577161aae.gif";